module.exports = __webpack_public_path__ + "img/line-logo.dc5b2bb3.svg";